import { motion } from "framer-motion";
import { Check, Clock, Star } from "lucide-react";
import BuyServiceButton from "../BuyServiceButton";

/**
 * Rich service card. All content comes from the API (services collection).
 * Fields: title, tag, tagline, short, features[], turnaround, price, currency, featured
 */
export default function ServiceDetailCard({ service, index }) {
  const {
    title,
    tag,
    tagline,
    short,
    features = [],
    turnaround,
    price,
    currency,
    featured,
  } = service;

  return (
    <motion.article
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: (index || 0) * 0.05, ease: [0.22, 1, 0.36, 1] }}
      className="service-card p-6 md:p-10 flex flex-col justify-between gap-8 -ml-px -mt-px relative"
      data-testid={`service-detail-${service.slug || service.id}`}
    >
      {featured && (
        <span
          className="absolute top-6 right-6 inline-flex items-center gap-1.5 px-2 py-1 border border-[#2A5BFF] text-[9px] tracking-[0.28em] uppercase text-[#2A5BFF]"
          data-testid="service-featured-badge"
        >
          <Star size={10} /> Featured
        </span>
      )}
      <header>
        <div className="flex items-center justify-between mb-6 pr-24">
          <span className="text-[10px] tracking-[0.28em] uppercase text-white/40">
            {String((index || 0) + 1).padStart(2, "0")}
          </span>
          {tag && <span className="text-[10px] tracking-[0.28em] uppercase text-[#2A5BFF]">{tag}</span>}
        </div>
        <h3 className="font-anton uppercase text-3xl md:text-4xl leading-[0.95] tracking-wide">
          {title}
        </h3>
        {tagline && <p className="mt-3 text-white/80 text-lg font-light">{tagline}</p>}
        {short && <p className="mt-4 text-white/50 leading-relaxed">{short}</p>}
      </header>

      {features.length > 0 && (
        <ul className="space-y-3">
          {features.map((f) => (
            <li key={f} className="flex items-start gap-3 text-white/70 text-sm">
              <Check size={16} className="text-[#2A5BFF] mt-0.5 flex-none" />
              <span>{f}</span>
            </li>
          ))}
        </ul>
      )}

      <footer className="flex items-end justify-between border-t border-white/10 pt-5 gap-4 flex-wrap">
        <BuyServiceButton service={service} />
        {turnaround && (
          <div className="inline-flex items-center gap-1.5 text-[10px] tracking-[0.28em] uppercase text-white/60" data-testid="service-turnaround">
            <Clock size={12} className="text-[#2A5BFF]" />
            {turnaround}
          </div>
        )}
      </footer>
    </motion.article>
  );
}
